<template>

  <modalo
    :creating="creating"
    :title="null"
    type="medium"
    :padding="'0px'"
    @hideModal="hideModal()">

    <template slot="header">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Notifications') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <router-link
              class="btn btn-sm btn-light"
              to="/config/notify">
              <i class="fas fa-cog" /> {{ $t('Settings') }}
              </router-link>
          </div>
        </div>
      </div>
    </template>

    <Paginaty
      :total="paginate.total"
      :pages="paginate.pages"
      :page="paginate.page"
      :creating="creating"
      :loading="loading"
      @changePage="loadData">
      
      <template slot="content">
        <div class="list-group list-group-flush feedlist">
          <notification-list-item
            v-for="(notification, index) in notifications"
            :key="index"
            :notification="notification">
            </notification-list-item>
        </div>
      </template>

      <template slot="noresults">
        {{ $t('There are no items') }}
      </template>

    </Paginaty>

  </modalo>

</template>

<script>
import Paginaty from '@/components/Paginaty/Paginaty'
import NotificationListItem from './NotificationListItem'

export default {
  name: 'NotificationList',
  components: {
    Paginaty,
    NotificationListItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      sort: '-created_at',
      filters: {}
    }
  },
  computed: {
    notifications () {
      return this.$store.getters.getNotifications
    },
    paginate () {
      return this.$store.getters.getNotificationsPaginate
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectNotifications', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
        this.$store.dispatch('updateAllRead')
      })
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Notification/NotificationList.vue